import React from 'react';
import request from "arcdynamic-request";
import {SELLERS} from "../../consts/tables";
import Alert from "../Alert";
import SellerForm from "../SellerForm/SellerForm";
import { ApolloConsumer } from '@apollo/client';
import { CREATE_UPDATE_SELLER_DRAWER } from '../Graphql/mutations';
import { CREATE_OR_UPDATE_CONTACTS_SELLERS } from '../Graphql/ContactsMutations/allContactsMutation';
import { mutateData } from '../Service/graphQlService';

export default class SellerDrawer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {},
            paneIndex: 0,
            isBusy: null,
            error: null,
        };
        this.client = null;
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleDropdownChange = this.handleDropdownChange.bind(this);
        this.saveData = this.saveData.bind(this);
    }

    componentDidUpdate(prevProps){
        if(prevProps.resetDrawer !== this.props.resetDrawer && this.props.resetDrawer === true)
            this.setState({data:{}});
    }
    
    handleSubmit(e) {
        e.preventDefault();
        //condition added newly
        if(this.client){
        this.saveData(this.client);
        }
    }

    handleChange(key, value) {
        const data = {...this.state.data};
        data[key] = value;
        this.setState({data});
    }

    handleDropdownChange(query, queryType, x, key) {
        const data = {...this.state.data};
        if (key === 'STATUS') {
            // data.LAST_MODIFIED = new Date().toLocaleDateString("en-US");
            // if (!query[key]) {
            //     data.CATEGORY = null;
            //     data.TYPE = null;
            //     data.SINGLE_TENANT_SUBCATEGORY = null;
            //     data.MULTI_TENANT_SUBCATEGORY = null;
            //     data.MARKET = null;
            //     data.PRICE_MIN = null;
            //     data.PRICE_MAX = null;
            //     data.CAP_RATE_MIN = null;
            //     data.CAP_RATE_MAX = null;
            //     data.STRIVE_AGENT = null;
            // }
            data.last_modified = new Date().toLocaleDateString("en-US");
            if (!query[key]) {
                data.category = null;
                data.type = null;
                data.single_tenant_subcategory = null;
                data.multi_tenant_subcategory = null;
                data.market = null;
                data.price_min = null;
                data.price_max = null;
                data.cap_rate_min = null;
                data.cap_rate_max = null;
                data.strive_agent = null;
            }
        }
        data[key] = query[key];
        this.setState({data});
    }

    async saveData(client) {
        if (this.state.isBusy) return;

        this.setState({
            isBusy: true,
            error: null,
        });

        Object.keys(this.state.data).forEach(k => {
            if (!this.state.data[k] || k === 'undefined') {
                const newData = {...this.state.data};
                delete newData[k];
                this.setState({data: newData})
            }
        });

        // return request(arc.path.api, {
        //     service: 'arcimedes',
        //     action: 'open.datasource.table.Data.updateByTableCode',
        //     params: [SELLERS, {
        //         value: [
        //             this.state.data,
        //         ],
        //     }],
        // }).then(res => {
            const token = localStorage.getItem('authToken');
        try {
            const input = {};

            // List of fields to include in the input
            // const payloadFields = [
            //     "FIRST_NAME",
            //     "LAST_NAME",
            //     "PHONE",
            //     "EMAIL",
            //     "PROFILE",
            //     "STATUS",
            //     "NOTES",
            //     "COMPANY_NAME",
            //     "COMPANY_ADDRESS",
            //     "COMPANY_CITY",
            //     "COMPANY_STATE",
            //     "COMPANY_ZIP"
            // ];
            const payloadFields = [
                "first_name",
                "last_name",
                "phone",
                "email",
                "profile",
                "status",
                "notes",
                "company_name",
                "company_address",
                "company_city",
                "company_state",
                "company_zip"
            ];

            // Dynamically add fields to the input if they exist in `this.state.data`
            payloadFields.forEach(field => {
                if (this.state.data[field]) {
                input[field] = this.state.data[field] ;
                }
            });
            input.contact_type = "Investor";
        // const res = await client.mutate({
        //    // mutation: CREATE_UPDATE_SELLER_DRAWER,
        //   mutation: CREATE_OR_UPDATE_CONTACTS_SELLERS,
        //   variables: {
        //     input: input
        //   },
        //   context: {
        //     headers: {
        //       authorization: `Bearer ${token}`,  // Bearer token added here
        //     },
        //   },
        // })
        const res = await  mutateData(CREATE_OR_UPDATE_CONTACTS_SELLERS,{input});
            //if (res && res.success) {
                //if (res && res.data.createOrUpdateSellers.success) {
                if (res && res.data.createOrUpdateContact.success) {
                this.setState({isBusy: false});
                //this.props.savedNewItem(res.data[0]);
                //this.props.savedNewItem(res.data.createOrUpdateSellers.data[0]);
                this.props.savedNewItem(res.data.createOrUpdateContact.contact);
                if (this.props.closeDrawer) {
                    this.props.closeDrawer();
                    setTimeout(() => this.setState({data: {}}))
                }
            } else {
                this.setState({
                    isBusy: null,
                    //error: res && res.message ? res.message : 'Unspecified error',
                    //error: res && res.data.createOrUpdateSellers.message ? res.data.createOrUpdateSellers.message : 'Unspecified error',
                    error: res && res.data.createOrUpdateContact.message ? res.data.createOrUpdateContact.message : 'Unspecified error',
                });
            }
        //});
    } catch (error) {
        console.error("Error in handleSubmit:", error);
      }
    }

    render() {
        const data = this.state.data;
        return (
            <ApolloConsumer>
            {client => {
                if (!this.client) {
                    this.client = client;
                }
                return (
            <React.Fragment>
                <SellerForm data={data}
                            paneIndex={this.state.paneIndex}
                            handleSubmit={this.handleSubmit}
                            handleCancel={this.props.closeDrawer}
                            handleParentChange={this.handleChange}
                            handleParentDropdownChange={this.handleDropdownChange}
                            handlePaneChange={(key) => this.setState({paneIndex: key})}
                />
                {this.state.error && <Alert type='error'>{this.state.error}</Alert>}
            </React.Fragment>
             )
            }}
    
        </ApolloConsumer>
        )
    }
}